/**
 * ERP 티켓 상세 점유 해제 (POST /api/v1/open-mile/unpick/{ticketId}?brandId=)
 * 상세 화면, 로그아웃, 탭 닫기가 같은 점유를 중복 해제하지 않도록 상태를 공유한다.
 */

let currentPick = null;
let releaseTask = null;
const releasedKeys = new Set();

const normalizePick = (ticketId, brandId) => {
  const ticketNum = Number(ticketId);
  const brandNum = Number(brandId);
  if (!ticketNum || ticketNum <= 0 || Number.isNaN(ticketNum)) return null;
  if (!brandNum || brandNum <= 0 || Number.isNaN(brandNum)) return null;
  return { ticketId: ticketNum, brandId: brandNum };
};

const pickKey = (pick) => `${pick.ticketId}:${pick.brandId}`;

export const markErpTicketPick = (ticketId, brandId) => {
  const pick = normalizePick(ticketId, brandId);
  if (!pick) return null;
  releasedKeys.delete(pickKey(pick));
  currentPick = pick;
  return pick;
};

export const clearErpTicketPickMark = () => {
  currentPick = null;
};

/**
 * @param {Function} http axios 호출 함수
 * @param {number|string} [ticketId] 없으면 현재 점유 중인 티켓
 * @param {number|string} [brandId]
 */
export const releaseErpTicketPick = (http, ticketId, brandId) => {
  const explicit = normalizePick(ticketId, brandId);
  const pick = explicit || currentPick;
  if (!pick || typeof http !== 'function') return Promise.resolve(false);

  const key = pickKey(pick);
  if (releasedKeys.has(key)) {
    if (currentPick && pickKey(currentPick) === key) currentPick = null;
    return Promise.resolve(true);
  }
  if (releaseTask && releaseTask.key === key) return releaseTask.promise;

  if (currentPick && pickKey(currentPick) === key) currentPick = null;

  const promise = http({
    url: `/api/v1/open-mile/unpick/${pick.ticketId}`,
    method: 'POST',
    params: {
      brandId: pick.brandId
    },
    NProgress: false
  })
    .then(() => {
      releasedKeys.add(key);
      return true;
    })
    .catch((err) => {
      console.error(err);
      return false;
    })
    .finally(() => {
      if (releaseTask && releaseTask.key === key) releaseTask = null;
    });

  releaseTask = { key, promise };
  return promise;
};

/** 탭 닫기·브라우저 이탈. 페이지가 내려가도 요청이 유지되도록 keepalive 를 사용한다. 새로고침은 호출하지 않는다. */
export const releaseErpTicketPickKeepalive = (extraHeaders = {}) => {
  const pick = currentPick;
  if (!pick) return false;

  const key = pickKey(pick);
  if (releasedKeys.has(key)) {
    currentPick = null;
    return false;
  }

  const token = localStorage.getItem('token');
  if (!token) return false;

  currentPick = null;
  releasedKeys.add(key);

  const base = process.env.BASE_URL || '';
  const url = `${base}/api/v1/open-mile/unpick/${pick.ticketId}?brandId=${encodeURIComponent(pick.brandId)}`;
  fetch(url, {
    method: 'POST',
    keepalive: true,
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Requested-With': 'XMLHttpRequest',
      ...extraHeaders
    }
  }).catch(() => {});
  return true;
};



// WEBPACK FOOTER //
// ./src/constants/custom/openLink/erpTicketPick.js